{
  "filter": {
    "all": "Tutti i fornitori",
    "country": "country",
    "direct": "Fornitori diretti",
    "indirectConfidential": "Fornitori indiretti, confidenziali",
    "nonConfidential": "Fornitori indiretti, non confidenziali"
  },
  "list": {
    "countContact_one": "{{count}} Contatto",
    "countContact_many": "countContact",
    "countContact_other": "{{count}} Contatti",
    "noAddress": "Nessun indirizzo fornito",
    "noSuppliers": "Nessun fornitore trovato",
    "searchPlaceholder": "Cerca",
    "supplierTypePlaceholder": "Tipo di fornitore"
  },
  "productionSites": {
    "columns": {
      "confidential": "Fornitore confidenziale",
      "contactEmail": "Email di contatto",
      "country": "Paese",
      "internalCode": "Codice interno",
      "name": "Nome",
      "parentCompany": "Parent business partner",
      "performedActivities": "Attività svolte",
      "registrationId": "ID di registrazione del sito"
    },
    "filters": {
      "searchPlaceholder": "Cerca"
    },
    "search": {
      "placeholder": "placeholder"
    },
    "title": "Siti di produzione"
  },
  "repository": {
    "actions": {
      "delete": "Elimina",
      "edit": "Modifica"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "Alto",
    "low": "Basso",
    "medium": "Medio",
    "table": {
      "certificationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      },
      "collaborationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      }
    }
  },
  "sort": {
    "averageResponseTime": "averageResponseTime",
    "company": "company",
    "completedProductionSiterequests": "completedProductionSiterequests",
    "completedProductrequests": "completedProductrequests",
    "completedScopeCertificaterequests": "completedScopeCertificaterequests",
    "completedTransactionCertificaterequests": "completedTransactionCertificaterequests",
    "email": "email",
    "lastConnectionDate": "lastConnectionDate",
    "lastReminderDate": "lastReminderDate",
    "name": "name",
    "pendingDocumentrequests": "pendingDocumentrequests",
    "pendingProductionSiterequests": "pendingProductionSiterequests",
    "pendingProductrequests": "pendingProductrequests",
    "pendingScopeCertificaterequests": "pendingScopeCertificaterequests",
    "pendingTransactionCertificaterequests": "pendingTransactionCertificaterequests"
  },
  "subSuppliers": {
    "title": "I miei fornitori"
  },
  "supplier": {
    "averageResponseTime": "Tempo medio di risposta",
    "averageResponseTimeValue_one": "{{nbDays}} giorno",
    "averageResponseTimeValue_many": "{{nbDays}} giorni",
    "averageResponseTimeValue_other": "{{nbDays}} giorni",
    "informationRequests": "Richieste di informazioni sui prodotti",
    "lastConnection": "Ultima connessione",
    "lastConnectionValue": "{{nbDays}} giorni fa",
    "lastReminderSent": "Ultima email inviata",
    "lastReminderSentValue": "{{nbDays}} giorni fa",
    "noLastConnection": "Ancora nessuna connessione",
    "noLastReminderSent": "Ancora nessuna email inviata",
    "noResponseTime": "Ancora nessuna risposta",
    "productionSites": "Siti di produzione",
    "scopeCertificates": "Certificati di scopo",
    "transactionCertificates": "Certificati di transazione",
    "transferContact_one": "Trasferisci {{count}} richiesta incompleta\na un altro contatto",
    "transferContact_many": "transferContact",
    "transferContact_other": "Trasferisci {{count}} richieste incomplete\na un altro contatto",
    "transferContactCertificates_one": "transferContactCertificates",
    "transferContactCertificates_many": "transferContactCertificates",
    "transferContactCertificates_other": "transferContactCertificates",
    "transferModal": {
      "companyCountry": "companyCountry",
      "companyCountryPlaceholder": "companyCountryPlaceholder",
      "companyName": "companyName",
      "companyNamePlaceholder": "companyNamePlaceholder",
      "email": "Email",
      "emailPlaceholder": "es.: mario@azienda.com",
      "name": "Nome",
      "namePlaceholder": "es.: Mario Rossi",
      "title": "Trasferisci contatto",
      "transfer": "Trasferisci",
      "transferSuccess_one": "transferSuccess",
      "transferSuccess_many": "transferSuccess",
      "transferSuccess_other": "transferSuccess"
    }
  },
  "title": "Società commerciali"
}
